<template>
  <b-modal
    v-model="editorShown"
    @ok="submitForm"
    title-html="<div style='font-size:17px;'>Upload File</div>"
    @shown="calculateWidth"
  >
    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="text-left mt-1 mr-2"></div>
        <div class="text-right mt-1 mr-2">
          <b-button @click="cancel" variant="secondary" :disabled="loading"
            >Cancel</b-button
          >
          <b-button
            v-if="uploadFileStep > 1"
            class="ml-2"
            variant="primary"
            @click="submitForm"
            :disabled="!file || loading"
          >
            <b-spinner
              v-if="loading"
              style="width: 1rem; height: 1rem; color: #ffffff;"
              label="Spinning"
            ></b-spinner>
            <span v-else>Save</span>
          </b-button>
        </div>
      </div>
    </template>
    <input
      ref="filePicture"
      @change="previewPictureFile"
      type="file"
      style="display: none;"
      accept="image/*"
      capture="camera"
    />
    <canvas
      ref="canvas"
      id="canvas"
      :width="modalWidth"
      :height="modalWidth"
    ></canvas>
    <div v-if="uploadFileStep == 1">
      <div class="d-flex justify-content-center mb-4">
        <b-button
          v-if="isMobile"
          class="action-upload"
          @click="takePicture"
          variant="primary"
          >Take Picture</b-button
        >
        <b-button
          v-else
          class="action-upload"
          @click="showPictureTaker"
          variant="primary"
        >
          Take Picture
        </b-button>
      </div>
      <div class="border-bottom border-dark-gray separator-or"></div>
      <div class="d-flex justify-content-center mb-4">
        <span class="bg-white px-2">OR</span>
      </div>
      <div class="d-flex justify-content-center">
        <b-button
          class="action-upload"
          @click="uploadFileStep = 3"
          variant="primary"
        >
          Upload File
        </b-button>
      </div>
    </div>
    <div v-if="uploadFileStep == 2">
      <div class="text-center mb-2">
        <img
          ref="preview"
          v-if="file"
          :height="isMobile ? null : modalWidth"
          :width="modalWidth"
          :src="fileUrl"
        />
        <video
          v-else
          ref="video"
          id="video"
          :width="modalWidth"
          :height="modalWidth"
          autoplay
        ></video>
      </div>
      <div class="d-flex justify-content-center">
        <b-button
          v-if="!file"
          class="action-upload rounded-circle"
          @click="savePicture"
          variant="outline-secondary"
          style="width: 40px; height:40px;padding: 2px 0px 0px;"
        >
          <i style="font-size:18px" class="fas fa-camera"></i>
        </b-button>
        <a
          class="mt-1"
          v-else
          style="font-size: 14px;"
          @click="() => (isMobile ? takePicture() : showPictureTaker())"
          variant="primary"
        >
          Retake
        </a>
      </div>
    </div>
    <div v-if="uploadFileStep == 3">
      <b-form-file
        :disabled="loading"
        v-model="file"
        ref="fileUpload"
      ></b-form-file>
      <b-alert
        class="mt-2"
        v-if="fileErrors.length > 0"
        show
        variant="danger"
        >{{ fileErrors[0] }}</b-alert
      >
    </div>
  </b-modal>
</template>

<script>
import { isMobile } from "../../helpers/general";
import documentServer from "../../server/document";
import documentGroupServer from "../../server/documentGroup";
export default {
  name: "DocumentFileUploadModal",
  props: ["sharedDocumentId", "isFormGroup"],
  data() {
    return {
      file: null,
      fileUrl: null,
      uploadFileStep: 1,
      modalWidth: 0,
      isMobile: isMobile(),
      fileErrors: [],
      loading: false
    };
  },
  async mounted() {
    this.file = null;
    this.uploadFileStep = 1;
  },
  methods: {
    async submitForm() {
      this.loading = true;
      if (this.fileSizeIsOk()) {
        if (this.isFormGroup) {
          try {
            await documentGroupServer.upload(this.sharedDocumentId, {
              file: this.file
            });
            this.loading = false;
          } catch (error) {
            this.loading = false;
          }
        } else {
          try {
            await documentServer.upload(this.sharedDocumentId, {
              file: this.file
            });
            this.loading = false;
          } catch (error) {
            this.loading = false;
          }
        }
        this.$emit("onModify");
      }
    },
    showPictureTaker() {
      this.file = null;
      this.uploadFileStep = 2;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: {
              width: {
                min: this.modalWidth,
                ideal: this.modalWidth,
                max: this.modalWidth
              },
              height: {
                min: this.modalWidth,
                ideal: this.modalWidth,
                max: this.modalWidth
              }
            }
          })
          .then(stream => {
            this.$refs.video.srcObject = stream;
            this.$refs.video.play();
          });
      }
    },
    async savePicture() {
      this.imgHeigth = this.$refs.video.clientHeight;
      this.$refs.canvas
        .getContext("2d")
        .drawImage(this.$refs.video, 0, 0, this.modalWidth, this.modalWidth);
      var url = this.$refs.canvas.toDataURL("image/png");
      this.fileUrl = url;
      await fetch(url)
        .then(res => res.blob())
        .then(blob => {
          this.file = new File([blob], "File name", { type: "image/png" });
        });
    },
    calculateWidth() {
      let box = document.querySelector(".modal-body");
      let width = box.clientWidth - 32;
      this.modalWidth = width;
    },
    takePicture() {
      this.$refs.filePicture.click();
    },
    async previewPictureFile(event) {
      const file = event.srcElement.files[0];
      var self = this;
      if (file) {
        self.file = null;
        self.uploadFileStep = 2;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function(e) {
          var myImage = new Image(); // Creates image object
          myImage.src = e.target.result; // Assigns converted image to image object
          myImage.onload = function() {
            var myContext = self.$refs.canvas.getContext("2d"); // Creates a contect object
            self.$refs.canvas.width = myImage.width; // Assigns image's width to canvas
            self.$refs.canvas.height = myImage.height; // Assigns image's height to canvas
            myContext.drawImage(myImage, 0, 0); // Draws the image on canvas
            var url = self.$refs.canvas.toDataURL("image/png");
            self.fileUrl = url;
            self.$refs.canvas.toBlob(async function(blob) {
              self.file = new File([blob], "File name", { type: "image/png" });
            });
          };
        };
      }
    },
    fileSizeIsOk() {
      this.fileErrors = [];
      const fileSize = (this.file.size / 1024 / 1024).toFixed(4);
      if (fileSize > 100) {
        this.fileErrors.push("File max size 100 mb");
        return false;
      }
      return true;
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>
.separator-or {
  margin-bottom: -13px;
}
.action-upload {
  font-size: 13px;
}
canvas {
  display: none;
}
</style>
